// Seasonal events — extracted from upgradesConfig in Fase 1 so each config
// file owns one domain. Events activate by calendar month and modulate
// customers, prices, reputation and expenses.

export interface SeasonalEvent {
  id: string
  name: string
  emoji: string
  description: string
  startMonth: number // 1-12
  duration: number // days
  effects: SeasonalEffect[]
}

export interface SeasonalEffect {
  type: 'customer_multiplier' | 'price_modifier' | 'reputation_boost' | 'expense_modifier'
  value: number
}

export const SEASONAL_EVENTS: SeasonalEvent[] = [
  {
    id: 'summer_rush',
    name: 'Temporada de Verano',
    emoji: '☀️',
    description: 'Máxima afluencia en pistas outdoor',
    startMonth: 6,
    duration: 90,
    effects: [
      { type: 'customer_multiplier', value: 1.5 },
    ],
  },
  {
    id: 'christmas_special',
    name: 'Especial Navidad',
    emoji: '🎄',
    description: 'Torneos especiales y promociones',
    startMonth: 12,
    duration: 30,
    effects: [
      { type: 'customer_multiplier', value: 1.2 },
      { type: 'price_modifier', value: 1.1 },
    ],
  },
  {
    id: 'spring_league',
    name: 'Liga Primavera',
    emoji: '🌸',
    description: 'Liga amateur de temporada',
    startMonth: 3,
    duration: 60,
    effects: [
      { type: 'reputation_boost', value: 0.01 }, // Per day
    ],
  },
  {
    id: 'maintenance_season',
    name: 'Temporada Baja',
    emoji: '🔧',
    description: 'Ideal para reparaciones',
    startMonth: 1,
    duration: 45,
    effects: [
      { type: 'customer_multiplier', value: 0.7 },
      { type: 'expense_modifier', value: 0.8 }, // 20% cheaper maintenance
    ],
  },
]
